import {
  GetItemDuration,
  GetItemName,
  GetItemSkinName,
  getBrackets,
  getFirstName,
} from "@/tool";
export default {
  filters: {
    GetItemDuration,
    GetItemName,
    GetItemSkinName,
    getBrackets,
    getFirstName,
  },
  data() {
    return {
      colorList: [
        "rgb(176, 195, 217)",
        "rgb(71, 132, 184)",
        "rgb(36, 113, 227)",
        "rgb(133, 36, 236)",
        "rgb(219, 28, 236)",
        "rgb(236, 53, 28)",
        "rgb(253, 255, 66)",
      ],
    };
  },
  computed:{
	svgShadow(){
		return `drop-shadow(5px 5px 5px ${this.colorList[this.rarity+1]})`
	}
  },
  props: {
    /** 奖品品级 */
    rarity: {
      type: Number,
    },

    /** 奖品概率 */
    rate: {
      type: Number,
    },

    /** 奖品图片 */
    picture: {
      type: String,
    },

    /** 奖品图片宽度 */
    width: {
      type: String,
      default: "200px",
    },

    /** 奖品名称 */
    name: {
      type: String,
    },

    /** 奖品价格 */
    price: {
      type: [Number, String],
    },

    /** 背景色透明度 */
    background_opacity: {
      type: [Number, String],
      default: 0.6,
    },

    /** 是否图片有品级背景 */
    has_picuter_rarity: {
      type: Boolean,
      default: false,
    },

    /** 是否有底部品级栏 */
    has_bottom_rarity_bar: {
      type: Boolean,
      default: false,
    },

    /** 是否有阴影 */
    has_shadow: {
      type: Boolean,
      default: false,
    },

    /** 是否有交互动画 */
    has_interactive: {
      type: Boolean,
      default: false,
    },

    /** 是否已选择 */
    is_checked: {
      type: Boolean,
      default: false,
    },

    /** 是否显示不再选择 */
    is_show_cancel_checked: {
      type: Boolean,
      default: false,
    },
  },
};
